import MultipleSelectFilters from "./MultiSelectFilterBar";

export default MultipleSelectFilters;
